const getQueryParams = (name: string) => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const searchParams = new URLSearchParams(url.search);
  const tsParam = searchParams.get(name);

  return tsParam;
};

export { getQueryParams };
